export const getConfigSubdomainDefault = () => {


    let dataConfig = {
        subdomain: '',
        idSuscripcion: -1,
        idEmpresaInit: -1,
        idiomaInit: '',
        title: '',
        urlLogoLogin: '',
        urlLogoFavicon: '',
        urlLogoMenu: '',
    };

    return dataConfig;

}

export const GetCurrentUserDefault = () => {


    let dataLogin = {
            userName: '',
            token: '',
            loading: false,
            errorMessage: null,
            subdomain: '',
            idSuscripcion:  -1,
            idEmpresa:  -1,
            idioma: '' ,
            sessionGUID: '',
            token_renewal_errors: 0,

        };

    return dataLogin;

}
